import React, { useState } from 'react';
import { View, TextInput } from 'react-native';
import Icon from 'react-native-vector-icons/Ionicons';
import {
  Button, Dialog, Paragraph, Portal,
} from 'react-native-paper';
import { useDispatch } from 'react-redux';
import { AppHeader } from '../../../components/common';
import { AppButton } from '../../../components/form';
import styles from './styles';
import { sendForgotEmail } from '../../../redux/actions/companyActions';

const ForgotPassword = ({ navigation, route }) => {
  const dispatch = useDispatch();
  const { type } = route.params;
  const [dialogShow, setDialogShow] = useState(false);
  const [email, changeEmail] = useState('');
  const handleSendEmail = () => {
    dispatch(sendForgotEmail(email, type));
    setDialogShow(true);
  };
  return (
    <>
      <Portal>
        <Dialog visible={dialogShow} onDismiss={() => setDialogShow(false)}>
          <Dialog.Title>Recuperação de senha</Dialog.Title>
          <Dialog.Content>
            <Paragraph>Uma nova senha foi enviada por e-mail</Paragraph>
          </Dialog.Content>
          <Dialog.Actions>
            <Button labelStyle={styles.textButtonTable} onPress={() => { setDialogShow(false); navigation.goBack(); }}>Ok</Button>
          </Dialog.Actions>
        </Dialog>
      </Portal>
      <AppHeader hasBack navigation={navigation} title="Esqueci Minha Senha" />
      <View style={styles.container}>
        <View>
          <TextInput
            value={email}
            onChangeText={(newMail) => changeEmail(newMail)}
            placeholder="E-Mail"
            keyboardType="email-address"
            style={styles.input}
          />
          <Icon name="mail-outline" style={styles.inputIcon} />
        </View>
        <AppButton
          disabled={!/^(.+)@(.+)(\..{2,})+$/g.test(email)}
          onPress={handleSendEmail}
          style={styles.button}
          labelStyle={styles.textButton}
          label="RECUPERAR SENHA"
        />
      </View>
    </>
  );
};

export default ForgotPassword;
